import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StakeholderContainerComponent } from './containers/stakeholder-container/stakeholder-container.component';



const routes: Routes = [
	{ path: 'stakeholder', component: StakeholderContainerComponent }
	
];

@NgModule({
	imports: [ RouterModule.forChild(routes) ],
	exports: [ RouterModule ]
})
export class StakeholderRoutingModule {}